export const ConnectorsTableconstant = {
  CONNECTORS_TABLE_SAGA: "CONNECTORS_TABLE_SAGA",
  CONNECTORS_TABLE_REQUEST: "CONNECTORS_TABLE_REQUEST",
  CONNECTORS_TABLE_RESPONSE: "CONNECTORS_TABLE_RESPONSE",
  CONNECTORS_TABLE_API: "/charger-types",

  POST_POWER_MAP_SAGA: "POST_POWER_MAP_SAGA",
  POST_POWER_MAP_REQUEST: "POST_POWER_MAP_REQUEST",
  POST_POWER_MAP_RESPONSE: "POST_POWER_MAP_RESPONSE",
  POST_POWER_MAP_API: "/vehicle-connector",
};
